/* eslint-disable react-hooks/exhaustive-deps */
// Chakra imports
import { Portal, Box, useDisclosure } from "@chakra-ui/react";
import Footer from "components/footer/FooterAdmin.js";
// Layout components
import Navbar from "components/navbar/NavbarAdmin.js";
import IconSidebar from "components/sidebar/IconSidebar";
import Sidebar from "components/sidebar/Sidebar.js";
import { SidebarContext } from "contexts/SidebarContext";
import React, { useState } from "react";
import {  useSelector } from "react-redux";
import { Route, Routes, useNavigate } from "react-router-dom";
import routes from "routes.js";

// Custom Chakra theme
export default function Dashboard(props) {
  const { ...rest } = props;
  const navigate = useNavigate();
  // states and functions
  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [collapseSidebar, setCollapseSidebar] = useState(false)
  const [sidebarActive, setSidebarActive] = useState(true)

  const { isAuth, currUser } = useSelector((state) => state.auth);

  
  const auth = currUser?.auth;
  // verifies if routeName is the one active (in browser input)
  const moduleAccess = module => auth?.some(a=> a.module === module)
  
  const roleAccess = (route)=>{
    const name = route?.module;
    const access = route?.access;
    const roleObj = auth && auth?.length > 0 && auth.find((item)=> item?.module === name);
    if(!roleObj){
      return false
    } else {
      return access.includes(roleObj?.access)
    }
  }
  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/admin/full-screen-maps";
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].items);
        if (collapseActiveRoute !== activeRoute) {
          // activeRoute = routes[i].name;
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].items);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].path) !== -1) {
          return routes[i].name;
        } else {
          const pName = window.location.pathname;
          if (isAuth && pName === "/") {
            window.location.pathname = "/dashboard";
          }
          if (!isAuth) {
            navigate("/sign-in");
          }
        }
      }
    }
    return activeRoute;
  };
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbar(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].secondary;
        }
      }
    }
    return activeNavbar;
  };
  const getActiveNavbarText = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveNavbar = getActiveNavbarText(routes[i].items);
        if (collapseActiveNavbar !== activeNavbar) {
          return collapseActiveNavbar;
        }
      } else if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbarText(routes[i].items);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].messageNavbar;
        }
      }
    }
    return activeNavbar;
  };

  
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (currUser && prop?.module !== 'All Category' && moduleAccess(prop?.module) && roleAccess(prop)) {
        if (prop.layout === "/") {
          return <Route path={prop.path} element={prop.component} key={key} />;
        }
        if (prop.collapse) {
          return getRoutes(prop.items);
        }
        if (prop.category) {
          return getRoutes(prop.items);
        } else {
          return null;
        }
      } if(prop?.name === 'All Category' || prop?.name === 'Vendor Details'){

        return <Route path={prop.path} element={prop.component} key={key} />;
      }
      else {
        return false
      }
    });
  };

 

  document.documentElement.dir = "ltr";
  const { onOpen } = useDisclosure();
  document.documentElement.dir = "ltr";

  const handleSidebar = ()=>{
    setSidebarActive(!sidebarActive)
    setCollapseSidebar(!collapseSidebar)
  }
 
  return (
    <Box>
      <Box>
        <SidebarContext.Provider
          value={{
            toggleSidebar,
            setToggleSidebar,
          }}
        >
          {!collapseSidebar ?
          <Sidebar routes={routes} display="none" {...rest} collapse={collapseSidebar} handleSidebar={handleSidebar} />
          :
          <IconSidebar routes={routes} display="none" {...rest} handleSidebar={handleSidebar} />

          }
          <Box
            float="right"
            minHeight="100vh"
            height="100%"
            position="relative"
            maxHeight="100%"
            w={{ base: "100%", xl: `calc( 100% - ${collapseSidebar ? '35px' : '280px'} )` }}
            maxWidth={{ base: "100%", xl: `calc( 100% - ${collapseSidebar ? '35px' : '280px'} )` }}
            transition="all 0.43s cubic-bezier(0.685, 0.0473, 0.346, 1)"
            transitionDuration=".3s, .3s, .35s"
            // transitionProperty="top, bottom, width"
            transitionTimingFunction=" ease-in-out"
            // transition= "all 0.3s ease-in-out"
          >
            

            <Portal>
              <Box>
                <Navbar
                  onOpen={onOpen}
                  logoText={"Embrill"}
                  brandText={getActiveRoute(routes)}
                  secondary={getActiveNavbar(routes)}
                  message={getActiveNavbarText(routes)}
                  fixed={fixed}
                  collapseSidebar={collapseSidebar}
                  {...rest}
                />
              </Box>
            </Portal>

            {getRoute() ? (
              <Box
                mx="auto"
                // p={{ base: "20px", md: "30px" }}
                pe="20px"
                minH="100vh"
                pt="50px"
              >
                <Routes>
                  {getRoutes(routes)}
                  {/* <Route path='/all-category' element={<AllCategory/>} />; */}
                  {/* <Redirect from="/" to="/admin/default" /> */}
                  {/* <Redirect from="/" to="/auth/sign-in" /> */}
                </Routes>
              </Box>
            ) : null}
            <Box>
              <Footer />
            </Box>
          </Box>
        </SidebarContext.Provider>
      </Box>
    </Box>
  );
}
